import React from 'react';
import Section from './Section';

const Convenios = () => {
  const parceiros = [
    {
      img: '/imagem/convenios/aeago e mutua.png',
      alt: 'Convênio AEAGO e Mútua',
      link: 'https://www.mutua.com.br/',
    },
    {
      img: '/imagem/convenios/aeago univassouras.png',
      alt: 'Convênio AEAGO e Univassouras',
      link: 'https://univassouras.edu.br/',
    },
    {
      img: '/imagem/novamed.jpeg',
      alt: 'Convênio AEAGO e Novamed',
      link: 'https://www.novamedplanosdesaude.com.br/',
    },
    {
      img: '/imagem/uneed.jpeg',
      alt: 'Convênio AEAGO e Uneed',
      link: 'https://uneed.com.br/',
    },
  ];

  return (
    <Section id="convenios" bgClass="bg-white" title="Convênios">
      <p className="max-w-3xl mx-auto text-center mb-10 text-gray-700">
        Conheça nossos parceiros. A AEAGO firma convênios que ampliam os
        benefícios oferecidos aos associados, com condições especiais em
        saúde, educação e outros serviços.
      </p>

      <div className="max-w-4xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8">
        {parceiros.map((item) => (
          <a
            key={item.img}
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-white rounded-xl p-8 shadow hover:shadow-lg transition-shadow flex items-center justify-center border border-gray-100"
          >
            <img
              src={process.env.PUBLIC_URL + encodeURI(item.img)}
              alt={item.alt}
              className="max-h-28 w-auto object-contain"
            />
          </a>
        ))}
      </div>
    </Section>
  );
};

export default Convenios;
